import { render, staticRenderFns } from "./ImpactSoundLevel.vue?vue&type=template&id=b2a01ee8&"
import script from "./ImpactSoundLevel.vue?vue&type=script&lang=js&"
export * from "./ImpactSoundLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports